/**
 * tdesign v0.3.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { useCallback, useEffect } from 'react';
import { useTouch } from './useTouch.js';
import getScrollParent from './getScrollParent.js';
import { supportsPassive } from './supportsPassive.js';
import useConfig from './useConfig.js';
import './canUseDom.js';
import '../_chunks/dep-c9dcffa1.js';
import '../_chunks/dep-9fe8d051.js';
import '../config-provider/ConfigContext.js';

var totalLockCount = 0;
function useLockScroll(rootRef, shouldLock) {
  var touch = useTouch();
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var BODY_LOCK_CLASS = "".concat(classPrefix, "-overflow-hidden");
  var onTouchMove = useCallback(function (event) {
    touch.move(event);
    var direction = touch.deltaY.current > 0 ? "10" : "01";
    var el = getScrollParent(event.target, rootRef.current);
    if (!el) return;
    var scrollHeight = el.scrollHeight,
      offsetHeight = el.offsetHeight,
      scrollTop = el.scrollTop;
    var status = "11";
    if (scrollTop === 0) {
      status = offsetHeight >= scrollHeight ? "00" : "01";
    } else if (scrollTop + offsetHeight >= scrollHeight) {
      status = "10";
    }
    if (status !== "11" && touch.isVertical() && !(parseInt(status, 2) & parseInt(direction, 2))) {
      if (event.cancelable) {
        event.preventDefault();
      }
    }
  }, [rootRef, touch]);
  var lock = useCallback(function () {
    document.addEventListener("touchstart", touch.start);
    document.addEventListener("touchmove", onTouchMove, supportsPassive ? {
      passive: false
    } : false);
    if (!totalLockCount) {
      document.body.classList.add(BODY_LOCK_CLASS);
    }
    totalLockCount += 1;
  }, [onTouchMove, touch.start, BODY_LOCK_CLASS]);
  var unlock = useCallback(function () {
    if (totalLockCount) {
      document.removeEventListener("touchstart", touch.start);
      document.removeEventListener("touchmove", onTouchMove);
      totalLockCount -= 1;
      if (!totalLockCount) {
        document.body.classList.remove(BODY_LOCK_CLASS);
      }
    }
  }, [onTouchMove, touch.start, BODY_LOCK_CLASS]);
  useEffect(function () {
    if (shouldLock) {
      lock();
      return function () {
        unlock();
      };
    }
  }, [shouldLock, lock, unlock]);
}

export { useLockScroll };
//# sourceMappingURL=useLockScroll.js.map
